module.exports = __webpack_public_path__ + "img/2024-10-16b_3.5b4b6dc4.jpg";